import type { ReactNode } from 'react';

export type IconSize = 'xs' | 'sm' | 'md' | 'lg';

export interface IconProps {
  /** Visual size of the icon */
  size?: IconSize;
  className?: string;
  children: ReactNode;
}

const sizeClasses: Record<IconSize, string> = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

/** Generic icon wrapper that enforces consistent sizing across all SVG icons. */
export function Icon({ size = 'md', className = '', children }: IconProps) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 ${sizeClasses[size]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}
